module.exports = __webpack_public_path__ + "img/GLOBAL_CAKES_AND_PASTRIES.a3803754.png";